import React from "react";

const LazyImage = React.forwardRef(function LazyImage({ src, alt, style, className, ...rest }, ref) {
    return (
        <img
            ref={ref}
            src={src}
            alt={alt}
            loading="lazy"
            decoding="async"
            style={style}
            className={className}
            {...rest}
        />
    );
});

export default LazyImage;
